(function($) {
    $.validator.addMethod("pattern", function (value, element, param) {
        if (!param.test) {
            param = new RegExp(param);
        }
        return this.optional(element) || param.test(value);
    }, "Invalid format.");

    var ignore = ":hidden";

    var val = $("form").validate({
        onsubmit: false,
        ignore: ignore
    });

    $('button[data-validates], input[type="submit"][data-validates]').click(function (e) {
        if (!itemsValid($('#' + $(e.currentTarget).data('validates')).find(':input').not(ignore))) {
            e.preventDefault();
        }
    });

    $('button[data-validation-group], input[type="submit"][data-validation-group]').click(function (e) {
        var group = $(e.currentTarget).data('validation-group');
        if (!itemsValid($(':input[data-validation-group="' + group + '"]').not(ignore))) {
            e.preventDefault();
        }
    });

    function itemsValid(items) {
        val.resetForm();

        var isValid = true;

        items.each(function (i, item) {
            if (!$(item).valid())
                isValid = false;
        });

        return isValid;
    }
})(jQuery);